import { LineInfo } from './../models/telemed.model';
import { Injectable } from '@angular/core';
import { DazForm, DazHistory ,TelemedInfo} from '../models/telemed.model'
@Injectable({
  providedIn: 'root'
})
export class TelemedStateActionService {

  constructor() { }
  private telemedInfo: TelemedInfo = {lineInfo:null,dazForm:null,dazHistory:null};

  // getTelemedInfo(): TelemedInfo {
  //   if (!this.telemedInfo) return {lineInfo:null,dazForm:null,dazHistory:null};
  //   return this.telemedInfo;
  // }

  get lineInfo(): LineInfo {
    if (!this.telemedInfo) return null;
    return this.telemedInfo.lineInfo;
  }
  setLineInfo(data:LineInfo):void{
    if (!data) return;
    this.telemedInfo.lineInfo = data;
  }

  get dazForm(): DazForm {
    if (!this.telemedInfo) return null;
    return this.telemedInfo.dazForm;
  }
  setDazForm(data:DazForm):void{
    if (!data) return;
    this.telemedInfo.dazForm = data;
  }

  get dazHistory(): Array<DazHistory> {
    if (!this.telemedInfo) return null;
    return this.telemedInfo.dazHistory;
  }
  setDazHistory(data:Array<DazHistory>):void{
    if (!data) return;
    this.telemedInfo.dazHistory = data;
  }

}
